var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.302,
    height: 13.302,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M5.879 7.154c-2.27-2.27-1.946-2.595-1.946-2.595l.973-.973a.917.917 0 0 0 0-1.3L2.888.27A.914.914 0 0 0 1.636.227a4.78 4.78 0 0 0-1.6 2.386C-.283 4.235 1.339 6.505 3.933 9.1s4.867 4.216 6.487 3.892a4.78 4.78 0 0 0 2.386-1.6.914.914 0 0 0-.043-1.252l-2.019-2.013a.917.917 0 0 0-1.3 0l-.97.973s-.324.324-2.595-1.946",
    "data-name": "Fill 1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/Social/Phone/main"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h13.302v13.302H0z",
    "data-name": "icon/Social/Phone/main background"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbdbdb",
    d: "M5.879 7.154c-2.27-2.27-1.946-2.595-1.946-2.595l.973-.973a.917.917 0 0 0 0-1.3L2.888.27A.914.914 0 0 0 1.636.227a4.78 4.78 0 0 0-1.6 2.386C-.283 4.235 1.339 6.505 3.933 9.1s4.867 4.216 6.487 3.892a4.78 4.78 0 0 0 2.386-1.6.914.914 0 0 0-.043-1.252l-2.019-2.013a.917.917 0 0 0-1.3 0l-.97.973s-.324.324-2.595-1.946",
    "data-name": "Fill 1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Mask Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3364fb",
    d: "M0 0h13.3v13.3H0Z",
    "data-name": "Color/Primary"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.09cd3cf9317b667b1099de33cfff623d.svg";
export { ForwardRef as ReactComponent };